import React from "react";
import { Table, Input, Button, Space } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";

import EmployeeDetails from "./EmployeeDetails";
import EditEmployee from "./EditEmployee";
// import Report from "./AttendanceReport/Details";

var currentdate = new Date();
// var onlydateend =
//   currentdate.getFullYear() +
//   "-" +
//   (currentdate.getMonth() + 1) +
//   "-" +
//   currentdate.getDate();
var onlydateend = currentdate.getFullYear() + "-" + "12" + "-" + "31";
var onlydatestartmonth =
  currentdate.getFullYear() + "-" + (currentdate.getMonth() - 1) + "-" + "1";
var onlydatestartyear = currentdate.getFullYear() + "-" + "01-01";

class Rendertable extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8, marginTop: -140 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const columns = [
      // {
      //   title: "SL.",
      //   key: "index",
      //   render: (text, record, index) => index + 1,
      // },
      {
        title: "Id",
        key: "id",
        // width: "20%",
        ...this.getColumnSearchProps("id"),
        render: (text, record, index) => 1000 + text["id"],
      },
      {
        title: "Image",
        dataIndex: "photo",
        key: "photo",
        render: (text, record, index) => (
          <img
            style={{ height: "30px", width: "30px" }}
            // alt="image"
            src={text}
          />
        ),
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        // width: "20%",
        ...this.getColumnSearchProps("name"),
      },
      {
        title: "Designation",
        dataIndex: "user_roleName",
        key: "Role",
        ...this.getColumnSearchProps("user_roleName"),
      },
      {
        title: "Branch",
        dataIndex: "branchName",
        key: "branchName",
        ...this.getColumnSearchProps("branchName"),
      },

      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone",
        ...this.getColumnSearchProps("phone"),
      },
      {
        title: "Address",
        dataIndex: "address",
        key: "address",
      },

      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        // width: "20%",
        ...this.getColumnSearchProps("email"),
      },
      {
        title: "Action",
        dataIndex: "",
        key: "x",
        render: (details) => (

          <>
            <Space>
              {this.props.brand.name == "ANZARA" && this.props.Auth?.profile?.user_role?.id == 34 ?
                null : <><EmployeeDetails
                  details={details}
                  setUpdatelist={this.props.setUpdatelist}
                  key="x"
                />
                  |
                </>}
              <EditEmployee
                details={details}
                loading={this.props.loading}
                setloading={this.props.setloading}
                updatelist={this.props.updatelist}
                setUpdatelist={this.props.setUpdatelist}
                key="x"
              />{" "}
              {/* |
              <Report
                startDate={onlydatestartmonth}
                startDateByYear={onlydatestartyear}
                endDate={onlydateend}
                employee={details.id}
                location={details.location}
              /> */}
            </Space>
          </>
        ),
      },
    ];
    return <Table columns={columns} dataSource={this.props.List} />;
  }
}

export default Rendertable;
